import { createSelector } from "reselect";

const userSelector = store => store.appStore?.user;

const customerCodesSelector = createSelector(userSelector, user => user?.customerUsers?.map(c => c?.customer?.code));

export { userSelector, customerCodesSelector };
